import { render, staticRenderFns } from "./stepTextBox.vue?vue&type=template&id=d9491726&"
import script from "./stepTextBox.vue?vue&type=script&lang=js&"
export * from "./stepTextBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/input/stepTextBox.vue"
export default component.exports